import { applyMiddleware, compose, StoreEnhancer  } from 'redux'
import thunk from 'redux-thunk';
import { api } from "../services/Api"

// const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancers: typeof compose =
  (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const enhancer: any = composeEnhancers(applyMiddleware(thunk.withExtraArgument({api})));

export default enhancer;
